//判断名称有重复
export function hasDuplicateNames(treeData) {
    const seenNames = new Set();
    
    function traverse(nodes) {
        for (const node of nodes) {
        if (seenNames.has(node.name)) {
            // 如果名称已经存在于集合中，则存在重复
            return true;
        }
        seenNames.add(node.name);
    
        // 如果有子节点，则递归遍历
        if (node.children && node.children.length > 0) {
            if (traverse(node.children)) {
            return true; // 如果子树中有重复，则直接返回 true
            }
        }
        }
        return false; // 当前分支没有重复
    }
    
    // 开始遍历根节点数组
    return treeData.some(node => {
        if (traverse([node])) {
        return true;
        }
        return false;
    });
    }

//获取最大ID
export function findMaxIdInTree(nodes) {
    let createID=0;
   const traverse = (nodeArray) => {
     for (const node of nodeArray) {
       const nodeId = parseInt(node.id, 10); // 确保 ID 是数字类型进行比较
       if (nodeId > createID) {
         createID = nodeId;
       }
       if (node.children && node.children.length > 0) {
         traverse(node.children);
       }
     }
   };

   traverse(nodes);
   return createID;
 }

 export function setDefaultNode(id,tree) {
  // 假设你想默认聚焦的节点的 id 是 5
  this.$nextTick(() => {
    const node = tree.getNode(id);
    if (node) {
      tree.setCurrentKey(id);
      //tree.setCurrentNode(node); // 可选，根据需求选择是否使用
    }
  });
}